var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgResend(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 16,
    viewBox: "0 0 14 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.45461 4.47171L4.26098 5.27777C4.54176 5.55855 4.54176 6.01379 4.26098 6.29457C3.9802 6.57535 3.52496 6.57535 3.24418 6.29457L1.21059 4.26098C0.929805 3.9802 0.929805 3.52496 1.21059 3.24418L3.24418 1.21059C3.52496 0.929805 3.9802 0.929805 4.26098 1.21059C4.54176 1.49137 4.54176 1.9466 4.26098 2.22738L3.45461 3.03374L7.15131 3.03359L7.25303 3.03443C10.6034 3.08946 13.3026 5.85781 13.3026 9.26479C13.3026 12.7062 10.5486 15.496 7.15131 15.496C3.75403 15.496 1 12.7062 1 9.26479C1 8.86771 1.31777 8.54581 1.70977 8.54581C2.10176 8.54581 2.41953 8.86771 2.41953 9.26479C2.41953 11.912 4.53802 14.058 7.15131 14.058C9.7646 14.058 11.8831 11.912 11.8831 9.26479C11.8831 6.61756 9.7646 4.47156 7.15131 4.47156L3.45461 4.47171Z",
    fill: "#1EC252",
    stroke: "#1EC252",
    strokeWidth: 0.4
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgResend);
export default __webpack_public_path__ + "static/media/resend.2c63118b.svg";
export { ForwardRef as ReactComponent };